// extracted by mini-css-extract-plugin
module.exports = {"noResultFound":"noResultFound_noResultFound__mcc5t","title":"noResultFound_title__IcHUd","paragraph":"noResultFound_paragraph__s6hcY"};